import { Box, Divider, makeStyles, Switch } from '@material-ui/core'

import { ReactComponent as AddCommentIcon } from 'assets/icons/add_comment.svg'

import { SpacedGroup } from '@guidde-co/shared.spaced-group'

import { logToAnalytics } from 'modules'

const useStyles = makeStyles(() => ({
    pointer: {
        cursor: 'pointer'
    }
}))

type Props = {
    videoElement: HTMLVideoElement | null
    playbookId: string
    isVisible: boolean
    onChange: () => void
    uid: string
    selectedStepId: string
    relativeTime: number
    isPlaybookQG: boolean
}

export const CommentsButton = ({
    videoElement,
    playbookId,
    onChange,
    isVisible,
    uid,
    selectedStepId,
    relativeTime,
    isPlaybookQG
}: Props) => {
    const classes = useStyles()

    return (
        <SpacedGroup>
            <SpacedGroup spacing={0}>
                <Switch
                    checked={isVisible}
                    size="small"
                    onChange={() => {
                        logToAnalytics('Comments', {
                            eventName: `Switch comments ${!isVisible ? 'On' : 'Off'}`,
                            user: uid,
                            playbookId: playbookId,
                            timeOffset: videoElement?.currentTime || 0
                        })

                        onChange()
                    }}
                    color="primary"
                />
                <Box fontSize="12px" fontWeight="400">
                    Comments {`${isVisible ? 'On' : 'Off'}`}
                </Box>
                <Divider
                    orientation="vertical"
                    light={true}
                    style={{ height: '18px', marginLeft: '12px' }}
                />
            </SpacedGroup>

            <SpacedGroup
                className={classes.pointer}
                spacing={1}
                mr={1}
                onClick={() => {
                    videoElement?.pause()

                    const locator = isPlaybookQG
                        ? `${selectedStepId}::${relativeTime}`
                        : `${Math.floor((videoElement?.currentTime || 0) * 1000)}`

                    window.inScreen.startThread(
                        `my-video::${playbookId}::${locator}`,
                        'inline-timeline-threads-display'
                    )
                }}
            >
                <Box style={{ cursor: 'pointer' }}>
                    <AddCommentIcon />
                </Box>

                <Box fontSize="12px" fontWeight="400" color="#090C10">
                    Comment
                </Box>
            </SpacedGroup>
        </SpacedGroup>
    )
}
